/* tslint:disable:class-name */
import { Injectable } from '@angular/core';
import { HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
//
// Library Model/Services
//
import { Response } from '../../../../lib/angular/model/common/response';
import { DealerOption } from '../../../../lib/angular/model/dealer/dealer-option';
import { RtiHttpService } from '../../../../lib/angular/service/rti-HttpService';

//
// App Service(s)
//
import { RtiJsonService } from '../../../../lib/angular/service/common/rti-JsonService';
import { ddHttpService } from '../dd-HttpService';
import * as Library from '../../../../lib/core/library';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';

@Injectable()
export class ddDealerOptionService extends ddHttpService {
  //
  // Rest API Endpoint
  //
  static readonly GET_API: string = 'dealer-products/marketplace-dio/dealers/dealerCode/dios';

  /**
   * getByCode()
   */
  public get(dealerCode: string, params: object): Observable<Response<DealerOption>> {
    let headers = new HttpHeaders();
    headers = headers.set(this._environment.RTI_X_API_KEY, this._environment.RTI_X_API_VALUE);
    const url = Library.replaceKeyValueWithString(ddDealerOptionService.GET_API, {dealerCode});
    return super._get<DealerOption>(url, this._map, params, headers);
    // return this._jsonService.get('assets/json/dealerOptions.service_2.json').pipe(
    //   map(items => new Response<DealerOption>(items.map(item => new DealerOption(item))))
    // );
  }

  /**
   * getByPartNumber()
   */
  public getByPartNumber(
    dealerCode: string,
    partNbr,
    params?: object
  ): Observable<Response<DealerOption>> {
    const url = Library.replaceKeyValueWithString(
      `${ddDealerOptionService.GET_API}/partNbr`,
      { dealerCode, partNbr }
    );
    let headers = new HttpHeaders();
    headers = headers.set(
      this._environment.RTI_X_API_KEY,
      this._environment.RTI_X_API_VALUE
    );
    return super._get<DealerOption>(url, this._map, params, headers);
    // return this._jsonService.get('assets/json/dealerOptions.service_2.json').pipe(
    //   map(items => new Response<DealerOption>(items.map(item => new DealerOption(item))))
    // );
  }

  /**
   * put()
   */
  public put(code: string, partNumber: string, model: DealerOption): Observable<Response<DealerOption>> {
    const url = `${ddDealerOptionService.GET_API}/_PART_NBR_`.replace(/_CODE_/g, code).replace(/_PART_NBR_/g, partNumber);
    return super._put<DealerOption>(url, model, null, this._map);
  }

  /**
   * post()
   */
  public post(code: string, model: any): Observable<Response<DealerOption>> {
    const url = ddDealerOptionService.GET_API.replace(/_CODE_/g, code);
    return super._post<DealerOption>(url, model, this._map);
  }

  /**
   * patch()
   */
  public patch(model: any): Observable<Response<DealerOption>> {
    return null;
  }

  /**
   * delete()
   */
  public delete(code: string, partNumber: string, ): Observable<Response<DealerOption>> {
    const url = `${ddDealerOptionService.GET_API}/_PART_NBR_`.replace(/_CODE_/g, code).replace(/_PART_NBR_/g, partNumber);
    return super._delete<DealerOption>(ddDealerOptionService.GET_API, {}, this._map);
  }

  /**
   * _map()
   */
  private _map(item: any): DealerOption {
    return new DealerOption(item);
  }

  /**
   * Function: constructor()
   */
  constructor(http: RtiHttpService,
              private _environment: EnvironmentConfiguration,
              private _jsonService: RtiJsonService) {
    super(http, _environment);
  }
}
